import {Moment} from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import DataConnector from 'connect/DataConnector';
import TimerActions from 'notebook/protocols/timers/TimerActions';
import TimerStore from 'notebook/protocols/timers/TimerStore';
import TimerComponent from 'notebook/protocols/viewer/TimerComponent';

import {EditHelpers} from '../timers/TimerConstants';
import {Timer} from '../timers/TimerTypes';

export interface StepTimerProps {
  inline: boolean;
  originalMS: number;
  playAudio?: boolean;
  allowEdits?: boolean;
  editHelpers?: EditHelpers;
}

interface EnhancedProps {
  timer?: Timer;
}

class StepTimerConnector extends DataConnector<StepTimerProps, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [TimerStore];

  enhanceProps(): EnhancedProps {
    return {timer: this.timerStore().getTimer(this.props.editHelpers!.cid)};
  }
}

class StepTimer extends React.PureComponent<StepTimerProps & EnhancedProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    inline: PropTypes.bool.isRequired,
    originalMS: PropTypes.number.isRequired,
    playAudio: PropTypes.bool,
    allowEdits: PropTypes.bool,
    editHelpers: PropTypes.object,
    timer: PropTypes.object,
  };

  static defaultProps = {
    playAudio: false,
  };

  _isMounted: boolean = false;

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override UNSAFE_componentWillReceiveProps(nextProps: StepTimerProps): void {
    if (this.props.timer != null && this.props.originalMS !== nextProps.originalMS) {
      _.defer(() => {
        // Avoid calling an action from within an another action
        if (this._isMounted) {
          TimerActions.updateTimer(this.props.timer!.id, {
            originalMS: nextProps.originalMS,
            startMS: nextProps.originalMS,
          });
        }
      });
    }
  }

  private getTimerStartMoment(): Moment | null {
    if (this.props.timer != null) {
      return this.props.timer.startMoment;
    } else {
      return null;
    }
  }

  private getTimerStartMS(): number {
    if (this.props.timer != null) {
      return this.props.timer.startMS;
    } else {
      return this.props.originalMS;
    }
  }

  private updateTimer = (properties: Partial<Timer>): void => {
    TimerActions.updateTimer(
      this.props.editHelpers!.cid,
      _.defaults(properties, {
        originalMS: this.props.originalMS,
        startMoment: this.getTimerStartMoment(),
        startMS: this.getTimerStartMS(),
      })
    );
  };

  override render(): JSX.Element {
    return (
      <TimerComponent
        inline={this.props.inline}
        originalMS={this.props.originalMS}
        startMoment={this.getTimerStartMoment()}
        startMS={this.getTimerStartMS()}
        playAudio={this.props.playAudio}
        requestChange={this.updateTimer}
        allowEdits={this.props.allowEdits}
        editHelpers={this.props.editHelpers}
      />
    );
  }
}

export default StepTimerConnector.connect(StepTimer);
